import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../../../axiosSetup';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
// import { updateEBLInstructionTypes } from '../slices/eBLDocumentHistorySlice';

export interface PartyName {
    value: string;
    text: string;
  }

  export interface BankName {
    value: string;
    text: string;
  }

  export const getEBLDetails = createAsyncThunk(
    'instruction/getEBLDetails',
    async (payload: any) => {
      try {
        const response = await axiosInstance.get(
            `api/gsbn/v1/eBl/${payload?.eBLNo}`
        );
        return response?.data;
  
      } catch (e) {
        const error = e as AxiosError;
        return {};
      }
    }
  );


  export const getTncConsent = createAsyncThunk(
  'instruction/getTncConsent',
  async (payload: { partnerId: string | number | null; countryCode: string; module:string; language:string}) => {

    if (!payload.partnerId) {
      
      return null;
    }

    try {
        const response = await axiosInstance.get('/api/master/v1/common/tnc-consent', {
        params: {
          partnerId: payload.partnerId,
          countryCode: payload.countryCode,
          module:payload.module,
          language:payload.language
          
        },
      });
        return response?.data;
  
      } catch (e) {
      const error = e as AxiosError;
      
      return null;
    }
  }
);

export const getEBLHistory = createAsyncThunk(
  'instruction/getEBLHistory',
  async (payload: any) => {
    try {
      const response = await axiosInstance.get(
          `api/gsbn/v1/eBl/${payload?.eBLNo}/history`
      );
      if (Array.isArray(response?.data) && response?.data?.length === 0) {
        return [];
      }
      return response?.data;

    } catch (e) {
      const error = e as AxiosError;
      return [];
    }
  }
);

export const getPartyNameList = createAsyncThunk(
    'instruction/getPartyNameList',
  
    () => {
        return [
            { value: 'Party16', text: 'Party16' },
            { value: 'Party2', text: 'Party2' },
            { value: 'Party3', text: 'Party3' },
            { value: 'Party4', text: 'Party4' },
            { value: 'Party5', text: 'Party5' },
            { value: 'Party6', text: 'Party6' },
            { value: 'org10', text: 'org10' }
          ];
        }
  
  
  );


  export const getBankNameList = createAsyncThunk(
    'instruction/getBankNameList',
  
    () => {
        return [
            { value: 'Bank16', text: 'Bank16' },
            { value: 'Bank2', text: 'Bank2' },
            { value: 'Bank3', text: 'Bank3' },
            { value: 'Bank4', text: 'Bank4' },
            { value: 'Bank5', text: 'Bank5' },
            { value: 'Bank6', text: 'Bank6' }
          ];
        }
  
  
  );

  export const getEBLInstructionTypes = createAsyncThunk(
    'eBLModedropdown/getEBLInstructionTypes',
    
    async (payload:any) => {
      try {
        
        const response = await axiosInstance.get(
          `/api/gsbn/v1/action/request/${payload?.eblNo}`
          
        );
        // let index = 0;
        
        // const instructionTypes = response.data.map((item: any) => ({
        //   value: item.codeId,
        //   text: item.codeDesc,
        //   index: index++,
        // }));
  
        // const instructionTypes = response.data.map((item: any) => ({
        //   id: item.id,
        //   actionName: item.actionName,
        //   displayName: item.displayName,
        //   index: index++,
        // }));
  
        return response?.data

        // dispatch(updateEBLInstructionTypes(response.data));
      } catch (e) {
        const error:any = e as AxiosError;
        toast.error(error?.response?.data?.error)
        return error;
      }
    }
  );

  export const submitEblActionRequest = createAsyncThunk(
    'instruction/submitEblActionRequest',
    async (payload: any) => {
      try {
        const response = await axiosInstance.post(
            `/api/gsbn/v1/action/request`,payload
        );
        return response?.data;
      } catch (e) {
        const error = e as AxiosError;
        return {};
      }
    }
  );


    export const agentInvite = createAsyncThunk(
    'instruction/agentInvite',
    async (payload:any) => {
      try {
        const response = await axiosInstance.get(
          `/api/gsbn/v1/eBl/agent/invite?email=${payload?.email}&remark=${payload?.remark}`
        );
        return response?.data
      } catch (e) {
        const error:any = e as AxiosError;
        return error;
      }
    }
  );

  export const getAgents = createAsyncThunk(
  'instruction/getAgents',
  async (payload: any) => {
    try {
      const response = await axiosInstance.get(
          `api/gsbn/v1/eBl/${payload?.eBLNo}/agents`
      );
      if (Array.isArray(response?.data) && response?.data?.length === 0) {
        return [];
      }
      return response?.data;

    } catch (e) {
      const error = e as AxiosError;
      return [];
    }
  }
);


export const getEblAgentOptions = createAsyncThunk(
  'instruction/getEblAgentOptions',
  async (payload: any) => {
    try {
      //?name=${payload?.name}&country=${payload?.country}`
      const response = await axiosInstance.get(
        `api/gsbn/v1/eBl/${payload?.eBLNo}/agents?taxId=${payload?.taxId}&name=${payload?.name}&country=${payload?.country}`);
      if (response?.data && response?.data !== '') {
        return response?.data?.map((c: any) => {
          return {
            ...c,
            label: c?.orgName,
            value: c?.orgName,
          };
        });
      } else {
        return [];
      }
    } catch (e) {
      const error = e as AxiosError;
      if ((error.response?.data as any)?.result) {
        toast.error((error?.response?.data as any)?.result ?? "Unable to fetch agent details. Please try again.");
      } 
      return [];
    }
  }
);